export default function setQuestionList(state, action) {
  state.questionList = action.payload;
}
